<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="purchaseReceiveSns"
        @select="selectTest"
        @select-all="selectAll">
      <template slot="adSearch">
        <div class="vm-search" style="width: auto;">
          <vm-search label="采购订单号">
            <el-input v-model.trim="filter.buyOrderNo" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="物料条码">
            <el-input v-model.trim="filter.materialSn" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.sAPMaterialNO" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creator" style="width: 170px" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.createTimeBegin"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 160px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.createTimeEnd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 160px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="40"/>
      <!--      <el-table-column prop="rowIndex" align="center" label="行号"/>-->
      <el-table-column prop="buyOrderNO" align="center" label="采购订单号"/>
      <el-table-column prop="podetailRowNO" align="center" label="采购订单明细行号"/>
      <el-table-column prop="palletSn" align="center" label="托盘Sn"/>
      <el-table-column prop="materialSn" align="center" label="物料条码"/>
      <el-table-column prop="sapmaterialNO" align="center" label="物料编号"/>
      <el-table-column prop="quantity" align="center" label="送货数量"/>
      <el-table-column prop="creator" align="center" label="创建人"/>
      <el-table-column prop="createTime" align="center" label="创建时间"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";

  export default {
    name: "PurchaseReceiveSnsList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        receiveStatu:constant.toSelect(constant.receiveStatus),
        show: "",
        pkid: "",
        filter: {
          materialSn: "",
          sAPMaterialNO: "",
          buyOrderNo: "",
          creator: "",
          createTimeBegin: "",
          createTimeEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
